(function () {
  'use strict';

  function initDragScroll(track) {
    var isDown = false;
    var startX = 0;
    var scrollStart = 0;
    var moved = false;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      moved = false;
      track.classList.add('is-dragging');
      startX = e.pageX;
      scrollStart = track.scrollLeft;
    });

    window.addEventListener('mouseup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var delta = e.pageX - startX;
      if (Math.abs(delta) > 4) moved = true;
      track.scrollLeft = scrollStart - delta;
    });

    // Prevent link/card clicks from firing right after a drag
    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  function initGallery(section) {
    var track = section.querySelector('[data-polaroid-track]');
    if (!track) return;
    initDragScroll(track);
  }

  function initAll() {
    document.querySelectorAll('[data-polaroid-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-polaroid-gallery]');
    if (section) initGallery(section);
  });
})();